const jsPDF = require('jspdf')

export const print = ({details,datePassage,prochaineDate,offset}) => {
  const doc = new jsPDF();

  const width = 98
  const height = 57
  let x = 5
  let y = 6
  
  const estPair = function(pVal){
    return +pVal % 2 == 0
  }
  
  // On boucle sur la liste des éleveurs
  for(let i=0;i<details.length;i++){
    const iTmp = String(i+offset)[String(i+offset).length-1] //+ offset
    if(+iTmp == 0 && i != 0 ){
      doc.addPage()
    }
    // xTmp et yTmp étant le point haut gauche de chaque cellule
    const xTmp = estPair(iTmp) ? x : x + width + 3
    const yTmp = estPair(iTmp) ? y + ( (iTmp / 2) * height) : y + ( ((iTmp-1) / 2) * height)
    
    //doc.roundedRect(xTmp, yTmp, width, height, 3, 3)

    
    // CIA GD
    doc.setFontStyle("normal")
    doc.setFontSize(16)
    doc.text('CIA GD', xTmp + 5 , yTmp + 10)

    // Exploitation
    doc.setFontSize(10)
    doc.text(details[i].tiers   ,xTmp + 35 , yTmp + 5)
    doc.text(details[i].nom     ,xTmp + 35 , yTmp + 9,{maxWidth:60})
    doc.text(details[i].adresse.replace('  ', '') ,xTmp + 35 , yTmp + 17,{maxWidth:60})

    // Message
    doc.setFontSize(12)
    doc.text(`Livraison d'azote du ${datePassage}.`,xTmp + 3,yTmp + 40,{maxWidth:90})
    doc.setFontStyle("bold")
    doc.text(`Le prochain passage est prévu le ${prochaineDate}.`,xTmp + 3,yTmp + 45,{maxWidth:90})

    // Téléphone
    doc.setFontSize(9)
    doc.setFontStyle("normal")
    doc.text("Tél : 06 32 18 96 16",xTmp + 3,yTmp + 55)

    // Ordre 
    doc.setFontSize(6)
    doc.text(`${details[i].ordre}`, xTmp + 94  , yTmp + 54)
  }

    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      // Ouverture du fichier pdf sur edge
      window.navigator.msSaveOrOpenBlob(doc.output("blob"), `Tournee_${(new Date()).toISOString()}.pdf`);
    } else {
      doc.save()
    }
}